<div name="language-switch-modal">
    <div class="modal-header">
        <div class="media">
            <button class="btn btn-tertiary btn-min mr-3" aria-label="Close" (click)="close()">
                <i class="jr-icon chevron-left"></i>
            </button>
            <div class="media-body">
                <h4 class="modal-title" id="drawerModalLabel">
                    Language
                </h4>
            </div>
        </div>
    </div>

    <div class="modal-body">
        <ul class="list-group">
            <li (click)="selectLanguage('EN')" [ngClass]="{'active': isCurrentLanguage('EN')}"
                class="OneLinkNoTx list-group-item list-group-item-action">
                English
            </li>
            <li (click)="selectLanguage('ES')" [ngClass]="{'active': isCurrentLanguage('ES')}"
                class="OneLinkNoTx list-group-item list-group-item-action active">
                Español
            </li>
        </ul>
    </div>
</div>